/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React, { memo } from 'react';
import { generateID } from '../../base/helper';
import './styles.scss';
import { EmptyPageProps } from './types';

/**
 * UI Toolkit Empty Page template
 * @public
 */

const EmptyPage: React.FC<EmptyPageProps> = ({
  id = generateID('clientos-ui-toolkit-empty-page'),
  children
}) => {
  return (
    <div
      className="clientos-ui-toolkit-empty-page"
      id={id}
    >
      <div
        className="clientos-ui-toolkit-empty-page__content"
        id={`${id}__content`}
      >
        {children}
      </div>
    </div>
  );
};

export default memo(EmptyPage);
